var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.231,
    opacity: 0.75,
    height: 43.728,
    viewBox: "0 0 41.231 43.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(-7.557 -1.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(8.057 1.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(17.436 9.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M457.652,44.186a11.3,11.3,0,1,0,11.3,11.3A11.3,11.3,0,0,0,457.652,44.186Zm0,.968a10.33,10.33,0,1,1-10.33,10.33A10.335,10.335,0,0,1,457.652,45.153Z",
    transform: "translate(-446.354 -44.186)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 1.396,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M264.392,103.7a3.957,3.957,0,0,0,0,7.854v5.968a2.992,2.992,0,0,1-2.5-2.95.484.484,0,1,0-.968,0,3.96,3.96,0,0,0,3.472,3.927v.934a.484.484,0,0,0,.968,0V118.5a3.957,3.957,0,0,0,0-7.854v-5.968a2.99,2.99,0,0,1,2.5,2.95.484.484,0,1,0,.968,0,3.959,3.959,0,0,0-3.472-3.927v-.934a.484.484,0,0,0-.968,0Zm.968,7.923v5.9a2.989,2.989,0,0,0,0-5.9Zm-.968-6.946a2.989,2.989,0,0,0,0,5.9Z",
    transform: "translate(-236.141 -90.392)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M242.828,130.459h.464a1.5,1.5,0,0,1,.751.2l4.162,2.4a2.471,2.471,0,0,0,1.236.331h19.807a3.027,3.027,0,0,0,3.027-3.026v0a3.025,3.025,0,0,0-3.024-3.024h-9.937a3.022,3.022,0,0,0-.834-2.7l-6.745-6.745a2.471,2.471,0,0,0-1.748-.724H242.8a2.473,2.473,0,0,0-2.446-2.115h-2.563a2.471,2.471,0,0,0-2.471,2.471V130.5a2.471,2.471,0,0,0,2.471,2.471h2.563a2.471,2.471,0,0,0,2.471-2.471Zm0-12.319v11.351h.464a2.47,2.47,0,0,1,1.235.331l4.162,2.4a1.507,1.507,0,0,0,.752.2h19.807a2.059,2.059,0,0,0,2.059-2.058v0a2.057,2.057,0,0,0-2.056-2.056h-10.3a3.023,3.023,0,0,1-.473.612h0a3.028,3.028,0,0,1-4.28,0l-4.785-4.786a.484.484,0,1,1,.684-.684l4.785,4.785a2.058,2.058,0,0,0,2.911,0h0a2.059,2.059,0,0,0,0-2.911l-6.745-6.745a1.507,1.507,0,0,0-1.064-.44Zm-.97-.693c0,.027,0,13.062,0,13.066a1.5,1.5,0,0,1-1.5,1.493h-2.563a1.5,1.5,0,0,1-1.5-1.5V117.528a1.5,1.5,0,0,1,1.5-1.5h2.563A1.5,1.5,0,0,1,241.858,117.447Z",
    transform: "translate(-235.322 -90.801)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(18.815 4.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M365.715,98.2V92.812a.484.484,0,1,0-.968,0V98.2a.484.484,0,1,0,.968,0Z",
    transform: "translate(-364.748 -92.328)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 1.135,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(37.631 4.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M365.715,98.2V92.812a.484.484,0,1,0-.968,0V98.2a.484.484,0,1,0,.968,0Z",
    transform: "translate(-364.748 -92.328)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 1.135,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(28.223 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M365.715,122.547v-6.728a.484.484,0,1,0-.968,0v6.728a.484.484,0,1,0,.968,0Z",
    transform: "translate(-364.748 -115.335)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 1.268,
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFees);
export default __webpack_public_path__ + "static/media/fees.083305fa4325c92e172eca4df4084011.svg";
export { ForwardRef as ReactComponent };